import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



const cardData = {
  keyword: "Ertiga On Rent in Pune  ",

"headingDescription": "SRS Cab Service offers Ertiga On Rent in Pune, providing a spacious, comfortable, and reliable travel solution for families, groups, and corporate clients. Our well-maintained Ertiga vehicles, experienced drivers, and timely service ensure smooth and hassle-free journeys across Pune and nearby destinations. Ideal for airport transfers, city tours, business trips, and weekend getaways, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and enjoyable travel experience.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a key landmark in Pune. Travelers renting an Ertiga from SRS Cab Service often visit this site to explore Maratha architecture and learn about Pune’s cultural heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important historical monument linked to India’s freedom movement. Visitors using Ertiga on Rent from SRS Cab Service often stop here to admire its gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is renowned for its scenic views and trekking trails. Travelers renting an Ertiga from SRS Cab Service often plan a visit for sightseeing and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Visitors using Ertiga on Rent from SRS Cab Service frequently stop here to experience spiritual serenity and local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva. Travelers renting an Ertiga from SRS Cab Service enjoy its historic charm and peaceful environment."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts. Visitors using Ertiga on Rent from SRS Cab Service explore Pune’s cultural and artistic heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers renting an Ertiga from SRS Cab Service often climb the hill for sightseeing and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a serene destination surrounded by water and hills. Visitors using Ertiga on Rent from SRS Cab Service often include this spot for relaxation and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped park ideal for calm walks. Travelers renting an Ertiga from SRS Cab Service enjoy its lush greenery and peaceful ambiance."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using Ertiga on Rent from SRS Cab Service often explore this landmark to learn about Pune’s rich history."
  }
],



services: [
{
name: "Ertiga on Rent Pune",
description: "Ertiga on rent Pune offers comfortable 7-seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga rentals in Pune."
},
{
name: "Ertiga Car on Rent in Pune",
description: "Ertiga car on rent in Pune provides reliable transportation for city and long-distance travel. Customers can book vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Rent Ertiga cars easily in Pune."
},
{
name: "Ertiga CNG on Rent in Pune",
description: "Ertiga CNG on rent in Pune offers economical travel for budget-friendly trips. Customers can book vehicles for cost-effective journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga CNG services."
},
{
name: "Ertiga Rent in Pune",
description: "Ertiga rent in Pune provides flexible vehicle options for local and outstation travel. Customers can book cars for family and business trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent Ertiga cars easily."
},
{
name: "Ertiga Rent per km in Pune",
description: "Ertiga rent per km in Pune offers clear pricing for travel planning. Customers can check per km rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose Ertiga services with transparent pricing."
},
{
name: "Ertiga Rental Pune",
description: "Ertiga rental Pune provides convenient transportation for all travel needs. Customers can rent vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga rental services."
},
{
name: "Maruti Ertiga on Rent in Pune",
description: "Maruti Ertiga on rent in Pune offers reliable travel for families and small groups. Customers can book vehicles for tours and trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Maruti Ertiga services."
},
{
name: "Pune to Shirdi Ertiga on Rent",
description: "Pune to Shirdi Ertiga on rent provides comfortable travel for temple visits. Customers can book vehicles for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with Ertiga."
},
{
name: "Pune to Shirdi Cab Package",
description: "Pune to Shirdi cab package offers complete travel solutions for devotees. Customers can book packages for darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Shirdi cab packages."
},
{
name: "Pune Airport to Shirdi Ertiga Cab Package",
description: "Pune airport to Shirdi Ertiga cab package provides direct travel from airport to temple. Customers can book vehicles for quick transfers. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from airport to Shirdi."
},
{
name: "Pune to Mahabaleshwar Ertiga Cab",
description: "Pune to Mahabaleshwar Ertiga cab offers comfortable travel for hill station trips. Customers can enjoy scenic journeys. Professional drivers ensure safe ghat road travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Pune to Kolhapur Ertiga Cab",
description: "Pune to Kolhapur Ertiga cab provides reliable travel for long-distance trips. Customers can book vehicles for family travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Pune to Kolhapur."
},
{
name: "Pune to Mumbai Ertiga Cab Booking",
description: "Pune to Mumbai Ertiga cab booking offers easy reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga booking services."
},
{
name: "Pune to Lonavala Ertiga Cab Booking",
description: "Pune to Lonavala Ertiga cab booking provides convenient travel for short trips. Customers can book vehicles for outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Lonavala with Ertiga."
},
{
name: "Pune to Goa Ertiga Cab",
description: "Pune to Goa Ertiga cab offers comfortable long-distance travel for vacations. Customers can enjoy spacious rides for beach trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Goa with Ertiga."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Pune to Mumbai airport Ertiga cab offers reliable airport transfer services. Customers can book vehicles for timely travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mumbai Airport with Ertiga."
},
{
name: "Pune to Ashtavinayak Darshan Ertiga Cab",
description: "Pune to Ashtavinayak darshan Ertiga cab provides comfortable travel for temple tours. Customers can visit multiple temples easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga darshan services."
},
{
name: "Pune to Shani Shingnapur Ertiga Cab",
description: "Pune to Shani Shingnapur Ertiga cab offers convenient travel for temple visits. Customers can book vehicles for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Pune to Outstation Ertiga Cab",
description: "Pune to outstation Ertiga cab provides reliable travel for long-distance trips. Customers can book vehicles for one-way or round journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with outstation Ertiga services."
},
{
name: "Pune to Solapur Ertiga Cab",
description: "Pune to Solapur Ertiga cab offers convenient travel for intercity journeys. Customers can book vehicles for business and family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from Pune to Solapur."
},
{
name: "Ertiga Cab Service Pune",
description: "Ertiga cab service Pune provides dependable transportation for all travel needs. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Ertiga Cab Pune",
description: "Ertiga cab Pune offers reliable travel for city and long-distance journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cabs in Pune."
},
{
name: "Ertiga Booking Pune",
description: "Ertiga booking Pune provides quick and easy reservation options. Customers can book cars online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Ertiga easily in Pune."
},
{
name: "Ertiga Cab Booking Pune",
description: "Ertiga cab booking Pune offers convenient booking options for travelers. Customers can reserve cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Ertiga cab easily."
},
{
name: "Ertiga Price per km Pune",
description: "Ertiga price per km Pune provides detailed pricing for travel planning. Customers can check per km rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Choose Ertiga services with transparent pricing."
},
{
name: "Ertiga on Hire Pune",
description: "Ertiga on hire Pune offers flexible travel solutions for all needs. Customers can hire vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Hire Ertiga cars easily in Pune."
},
{
name: "Ertiga Car Rental Pune",
description: "Ertiga car rental Pune provides convenient transportation for family and business travel. Customers can rent vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Rent Ertiga cars easily."
},
{
name: "Ertiga for Outstation Pune",
description: "Ertiga for outstation Pune offers reliable travel for long-distance trips. Customers can book vehicles for tours and business travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga outstation services."
},
{
name: "Ertiga for Local Travel Pune",
description: "Ertiga for local travel Pune provides convenient transportation within the city. Customers can book vehicles for daily and short trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with local Ertiga services."
}
],

tableData: [
["Ertiga on Rent Pune","Ertiga Car on Rent in Pune"],
["Ertiga CNG on Rent in Pune","Ertiga Rent in Pune"],
["Ertiga Rent per km in Pune","Ertiga Rental Pune"],
["Maruti Ertiga on Rent in Pune","Pune to Shirdi Ertiga on Rent"],
["Pune to Shirdi Cab Package","Pune Airport to Shirdi Ertiga Cab Package"],
["Pune to Mahabaleshwar Ertiga Cab","Pune to Kolhapur Ertiga Cab"],
["Pune to Mumbai Ertiga Cab Booking","Pune to Lonavala Ertiga Cab Booking"],
["Pune to Goa Ertiga Cab","Pune to Mumbai Airport Ertiga Cab"],
["Pune to Ashtavinayak Darshan Ertiga Cab","Pune to Shani Shingnapur Ertiga Cab"],
["Pune to Outstation Ertiga Cab","Pune to Solapur Ertiga Cab"],
["Ertiga Cab Service Pune","Ertiga Cab Pune"],
["Ertiga Booking Pune","Ertiga Cab Booking Pune"],
["Ertiga Price per km Pune","Ertiga on Hire Pune"],
["Ertiga Car Rental Pune","Ertiga for Outstation Pune"],
["Ertiga for Local Travel Pune","Ertiga on Rent Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable & Spacious Family Car",
    WhyChoosedescription: "SRS Cab Service offers Ertiga on rent in Pune, a perfect MPV for family trips with comfortable seating, smooth ride, and ample luggage space."
  },
  {
    WhyChooseheading: "Affordable Ertiga Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly Ertiga rental in Pune with transparent pricing. Rates typically start from ₹13 to ₹17 per km depending on travel type and duration."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Ertiga is perfect for Pune to Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, and airport travel, offering reliable and fuel-efficient long-distance journeys."
  },
  {
    WhyChooseheading: "24/7 Ertiga Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Ertiga bookings in Pune, making it convenient for early morning, late-night, and emergency travel."
  },
  {
    WhyChooseheading: "6+1 & 7+1 Seating Capacity",
    WhyChoosedescription: "Ertiga comes with 6+1 and 7+1 seating options, ideal for small groups, families, and corporate travel with comfortable seating."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "We provide trained and experienced drivers familiar with Pune routes and highways, ensuring safe and smooth travel experience."
  },
  {
    WhyChooseheading: "Clean & AC Well-Maintained Cars",
    WhyChoosedescription: "All Ertiga vehicles are fully air-conditioned, regularly serviced, and cleaned to provide a hygienic and comfortable ride."
  },
  {
    WhyChooseheading: "Trusted Ertiga Rental Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Ertiga on rent in Pune due to affordable pricing, punctual service, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Ertiga on rent in Pune?", answer: "Yes, SRS Cab Service offers Ertiga rental in Pune for local, airport, and outstation travel." },
  { question: "What is the price of Ertiga per km in Pune?", answer: "Ertiga rental in Pune typically starts from ₹13 to ₹17 per km depending on trip and duration." },
  { question: "Is Ertiga suitable for outstation trips?", answer: "Yes, Ertiga is ideal for outstation travel like Mumbai, Shirdi, Nashik, Lonavala, and more." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga has 6+1 and 7+1 seating options suitable for families and small groups." },
  { question: "Is Ertiga available for airport transfer?", answer: "Yes, Ertiga is widely used for Pune Airport and Mumbai Airport transfers." },
  { question: "Is Ertiga cab available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Are Ertiga cars air-conditioned?", answer: "Yes, all Ertiga vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book Ertiga online?", answer: "Yes, you can easily book Ertiga on rent in Pune online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip Ertiga cab services." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback:
      "Booked Ertiga from SRS Cab Service for family trip. Very comfortable and affordable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Deshmukh",
    feedback:
      "Best Ertiga rental in Pune. Clean car, smooth journey, and professional driver.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Ertiga on rent in Pune for local travel, airport transfers, and outstation trips. Book Ertiga cab services for Pune to Shirdi, Mahabaleshwar, Mumbai, Lonavala, Goa, Kolhapur, and more. Enjoy affordable per km rates, comfortable rides, and 24x7 online booking with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Ertiga On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Ertiga on rent in Pune with SRS Cab. Ideal for local travel, airport transfers, and outstation trips to Shirdi, Mahabaleshwar, Mumbai, Lonavala, Goa, Kolhapur and more. Affordable per km rates with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinpune;